<template>
    <main class="container_sv_mobile" id="sitevitrinemobile">
        <!--section top -->
        <section class="container_sv_mobile__section_top">
            <!-- article top -->
            <article class="container_sv_mobile__section_top__article_top">
                <aside class="container_sv_mobile__section_top__article_top__aside">
                    <div class="container_sv_mobile__section_top__article_top__aside__div">
                        <h1 class="container_sv_mobile__section_top__article_top__aside__div__h1">
                            Site vitrine
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_sv_mobile__section_top__article_bottom">
                <aside class="container_sv_mobile__section_top__article_bottom__aside">
                    <div class="container_sv_mobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/screen-3001951.png" alt="Site vitrine"
                            class="container_sv_mobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_sv_mobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_sv_mobile__section_top__article_bottom__aside__div_bottom__p">
                            Un site vitrine est un site Web qui présente en ligne les produits ou les services d'une
                            organisation, dans le but
                            d'attirer simplement l'attention et d'éveiller l'intérêt des internautes de passage, le plus
                            souvent sans permettre
                            d'acheter directement le produit ou le service proposé.
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
            <!-- hidden -->
            <article class="w3-container container_sv_mobile__section_top__article_hidden">
                <aside id="id01" class="w3-modal container_sv_mobile__section_top__article_hidden__aside">
                    <!-- div options -->
                    <div class="w3-modal-content container_sv_mobile__section_top__article_hidden__aside__div">
                        <div class="w3-container container_sv_mobile__section_top__article_hidden__aside__div__div">
                            <span onclick="document.getElementById('id02').style.display='none'"
                                class="w3-button w3-display-topright">&times;</span>
                            <h1 class="container_sv_mobile__section_top__article_hidden__aside__div__div__h1">
                                Options
                            </h1>
                            <p class="container_sv_mobile__section_top__article_hidden__aside__div__div__p">
                                - 100€ maquette sans animation ( adobe XD ) <br>
                                - 300€ maquette avec animations <br>
                                - 100€ la modifications et 50€ par jours de retard ( du client au sujet de la
                                modifications
                                maquette )<br>
                                - 100€ l'hébergement web<br>
                                - 1 000€ déplacement ( en France )( voir CGV pour plus d'information )<br>
                                - Maintenance 140€ l'ajout<br>
                                - Devis 100€<br>
                            </p>
                        </div>
                    </div>
                </aside>
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_sv_mobile__section_bottom">
            <article class="container_sv_mobile__section_bottom__article_top">
                <aside class="container_sv_mobile__section_bottom__article_top__aside_top">
                    <div class="container_sv_mobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_sv_mobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_sv_mobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_sv_mobile__section_bottom__article_top__aside_top__div_text__p">
                            - Maquette Adobe XD <br>
                            - 2 Modifications gratuites <br>
                            - Réalisation rapide <br>
                        </p>
                        <p class="container_sv_mobile__section_bottom__article_top__aside_top__div_text__prix">
                            Prix total : 1 600 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_sv_mobile__section_bottom__article_top__aside_bottom">
                    <div class="container_sv_mobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_sv_mobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_sv_mobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div class="container_sv_mobile__section_bottom__article_top__aside_bottom__div_right">
                        <button onclick="document.getElementById('id02').style.display='block'"
                            class="container_sv_mobile__section_bottom__article_top__aside_bottom__div_right__button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-plus-circle-fill container_sv_mobile__section_bottom__article_top__aside_bottom__div_right__button__svg"
                                viewBox="0 0 16 16">
                                <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                            </svg>
                        </button>
                    </div>
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_sv_mobile__section_bottom__article_bottom">
                <aside class="container_sv_mobile__section_bottom__article_bottom__aside_left">
                    <router-link class="container_sv_mobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/wordpress">
                        <button
                            class="container_sv_mobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back" id="div_button">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_sv_mobile__section_bottom__article_bottom__aside_right">
                    <router-link class="container_sv_mobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/application-web">
                        <button
                            class="container_sv_mobile__section_bottom__article_bottom__aside_right__router-link__button"> 
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next" id="div_button">
                                <img src="@/assets/next.png" alt="next" 
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'SiteVitrineMobile',
}
</script>

<style  lang=scss>
@import "@/style/components/Services/Site-vitrine/SiteVitrineMobile.scss";

router-link {
    display: block;
}

@media screen and(min-width: 926px) {
    #sitevitrinemobile {
        display: none;
    }
}
</style>